const responseListMindsets = {
  "payload": [
    {
      "idImagenEmpresa": 56,
      "idEmpresa": 164285,
      "nombre": "Paisaje_típico.jpg",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-249cd438-cddf-4a4d-b5e2-bc47e5cb71db-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman Spiderman",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 55,
      "idEmpresa": 164285,
      "nombre": "Paisaje_típico.jpg",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-31e2c39b-5959-48d9-afbd-a525dd95b735-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 54,
      "idEmpresa": 164285,
      "nombre": "Paisaje_típico.jpg",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-275348c7-e827-4e38-ab7c-797fa0dc11a3-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 52,
      "idEmpresa": 164285,
      "nombre": "Paisaje_típico.jpg",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-6aa8bf52-cf3f-421a-b888-cac76f80bf80-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 50,
      "idEmpresa": 164285,
      "nombre": "Paisaje_típico.jpg",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-f1f75201-3897-494a-a728-4f1f5a7b4018-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 49,
      "idEmpresa": 164285,
      "nombre": null,
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-582f8ae8-731e-41c8-92e2-846aed536ed0-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 48,
      "idEmpresa": 164285,
      "nombre": null,
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-d03d7ffd-cdb8-4459-8141-946b819ff367-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 47,
      "idEmpresa": 164285,
      "nombre": null,
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-835e4c05-3fea-49f7-b031-9b77541c3694-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 46,
      "idEmpresa": 164285,
      "nombre": null,
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-353d7dc9-f22d-4fef-9930-98bb21458d4e-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 45,
      "idEmpresa": 164285,
      "nombre": null,
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-94a65b4d-ed35-4b14-94ee-0e16b9fb06e5-paisaje_típico.jpg%22",
      "tituloBienvenida": "Spiderman 2",
      "cuerpoBienvenida": "Cuerpo de la marca empresarial",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    },
    {
      "idImagenEmpresa": 43,
      "idEmpresa": 164285,
      "nombre": "w",
      "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/spiderman.jpg",
      "tituloBienvenida": "Update titulo",
      "cuerpoBienvenida": "Update cuerpo",
      "tipoImagenEmpresa": "MarcaEmpresarial",
      "hasBusinessBrand": null,
      "estado": true
    }
  ]
};

const responseCreateMindset = {
  "payload": {
    "idImagenEmpresa": 56,
    "idEmpresa": 164285,
    "nombre": "Paisaje_típico.jpg",
    "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-249cd438-cddf-4a4d-b5e2-bc47e5cb71db-paisaje_típico.jpg%22",
    "tituloBienvenida": "Spiderman 2",
    "cuerpoBienvenida": "Cuerpo de la marca empresarial",
    "tipoImagenEmpresa": "MarcaEmpresarial",
    "hasBusinessBrand": true,
    "estado": true
  }
};

const responseUpdateMindset = {
  "payload": {
    "idImagenEmpresa": 56,
    "idEmpresa": 164285,
    "nombre": "Paisaje_típico.jpg",
    "urlImagenBienvenida": "https://ibliss-icons-dev.s3.amazonaws.com/marca_empresarial/164285-249cd438-cddf-4a4d-b5e2-bc47e5cb71db-paisaje_típico.jpg%22",
    "tituloBienvenida": "Spiderman 2",
    "cuerpoBienvenida": "Cuerpo de la marca empresarial",
    "tipoImagenEmpresa": "MarcaEmpresarial",
    "hasBusinessBrand": true,
    "estado": true
  }
};

export const service = {
  getListMindsets: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseListMindsets }), 1000);
  }),
  postCreateMindset: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseCreateMindset }), 1000);
  }),
  putUpdateMindset: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseUpdateMindset }), 1000);
  })
}